<div [ngClass]="'mb-12 flex justify-center items-center flex-col pb-12 mat-typography'" [ngStyle]="{'height': '100%'}"
     [style.marginTop]="mobile ? '0' : '10px'">

    <span
      *ngIf="cardSvgEl"
      [innerHTML]="cardSvgEl"
      [style.marginBottom]="mobile ? '0' : '32px'"
      class="generic-border-radius"
      id-="card_svg_element"
    >
    </span>

  <div [ngStyle]="{ 'padding': mobile ? '18%' : '1.5rem 10rem 1.5rem 10rem' }"
       class="bg-gray-300 flex flex-col justify-center items-center" style="border-radius: 12px">
    <mat-spinner
      class="loading-spinner mb-4"
      color="primary"
      diameter="75"
    >
    </mat-spinner>
    <span *ngIf="!confirmed">Confirming Transaction Status</span>
  </div>
</div>
